import { Badge } from "@/components/ui/badge";
import { SlidersHorizontal, ChevronDown } from "lucide-react";

// Shared Operations-First UI primitives (mirrors the approved MarketplaceOrders pattern):
// a comfortable/compact density toggle, a collapsible filter card, and an excel-table
// density class. Presentation only — no data, business logic, auth or PII touched.

export const DensityToggle = ({ density, setDensity, testid = "density-toggle" }) => (
  <div className="inline-flex rounded-md border border-slate-200 overflow-hidden" data-testid={testid}>
    {[["comfortable", "Comfortable"], ["compact", "Compact"]].map(([v, l]) => (
      <button key={v} data-testid={`${testid}-${v}`} onClick={() => setDensity(v)}
        className={`px-2.5 h-9 text-xs ${density === v ? "bg-slate-900 text-white" : "bg-white text-slate-600"}`}>{l}</button>
    ))}
  </div>
);

export const FilterCard = ({ open, setOpen, activeCount = 0, children, testid = "filters" }) => (
  <div className="rounded-xl border border-slate-200 bg-white p-4 space-y-3" data-testid={`${testid}-card`}>
    <button data-testid={`${testid}-toggle`} onClick={() => setOpen(!open)} className="flex items-center justify-between w-full text-left">
      <span className="text-sm font-semibold text-slate-700 flex items-center gap-2">
        <SlidersHorizontal className="w-4 h-4" />Filters
        {activeCount > 0 && <Badge variant="outline" className="text-[10px] text-sky-700 border-sky-300" data-testid={`${testid}-active`}>{activeCount} active</Badge>}
      </span>
      <ChevronDown className={`w-4 h-4 text-slate-400 transition-transform ${open ? "rotate-180" : ""}`} />
    </button>
    {open && <div className="space-y-3" data-testid={`${testid}-body`}>{children}</div>}
  </div>
);

export const tableDensity = (density) => (density === "compact" ? "excel-compact" : "");
